import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
import { useContactModal } from './ContactModalContext';
export const Pricing = () => {
  const {
    openModal
  } = useContactModal();
  const features = ['2 независимых экспертных оценки', 'Третье мнение бесплатно при расхождении', 'Структурированный PDF на понятном языке', 'Результат за 48 часов', 'Готовый список вопросов для вашего врача', 'Уточняющие вопросы экспертам после отчёта'];
  const selfPath = [{
    label: 'Платный нейрохирург',
    price: '5 000 – 8 000 ₽'
  }, {
    label: 'Платный невролог',
    price: '4 000 – 6 000 ₽'
  }, {
    label: 'Повторная расшифровка МРТ',
    price: '3 000 – 5 000 ₽'
  }, {
    label: 'Возможно — ещё один эксперт',
    price: '+5 000 ₽'
  }];
  const selfPathDownsides = ['2–3 недели на запись и визиты', 'Каждый врач говорит на медицинском языке', 'Никто не сводит мнения вместе', 'Врачи могут знать друг друга', 'Часто — те же клиники с теми же подходами'];
  return <section id="pricing" className="py-24 bg-offwhite" data-id="element-207">
      <div className="max-w-6xl mx-auto px-6" data-id="element-208">
        <FadeIn data-id="element-209">
          <h2 className="font-serif text-3xl md:text-4xl text-navy text-center mb-4" data-id="element-210">
            Сколько это стоит
          </h2>
          <p className="text-center text-navyLight mb-16 max-w-2xl mx-auto" data-id="element-211">
            Сравните с тем, во сколько обойдётся собрать те же мнения
            самостоятельно — в деньгах, времени и нервах.
          </p>
        </FadeIn>

        <div className="grid lg:grid-cols-2 gap-6 items-stretch max-w-5xl mx-auto" data-id="element-212">
          {/* Self path */}
          <FadeIn data-id="element-213">
            <div className="bg-beigeLight border border-beige rounded-3xl p-8 md:p-10 h-full" data-id="element-214">
              <div className="text-xs uppercase tracking-widest text-navyLight/60 font-medium mb-3" data-id="element-215">
                Если идти самостоятельно
              </div>
              <h3 className="font-serif text-2xl text-navy mb-2" data-id="element-216">
                Собрать мнения по разным клиникам
              </h3>
              <p className="text-sm text-navyLight mb-8" data-id="element-217">
                Путь, который проходят большинство — обычно с тем же
                результатом.
              </p>

              <div className="space-y-3 mb-8" data-id="element-218">
                {selfPath.map((row, i) => <div key={i} className="flex justify-between items-baseline text-sm border-b border-beige/70 pb-2.5" data-id="element-219">
                    <span className="text-navyLight" data-id="element-220">{row.label}</span>
                    <span className="font-medium text-navy/80 shrink-0 ml-3" data-id="element-221">
                      {row.price}
                    </span>
                  </div>)}
                <div className="flex justify-between items-baseline pt-4" data-id="element-222">
                  <span className="text-navy font-medium font-serif text-lg" data-id="element-223">
                    Итого
                  </span>
                  <span className="font-serif text-2xl text-navy" data-id="element-224">
                    17 000 – 24 000 ₽
                  </span>
                </div>
              </div>

              <div className="space-y-2.5 text-sm text-navyLight" data-id="element-225">
                {selfPathDownsides.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-226">
                    <X size={14} className="text-navyLight/40 mt-1 shrink-0" data-id="element-227" />
                    <span data-id="element-228">{item}</span>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          {/* Our pricing */}
          <FadeIn delay={0.1} data-id="element-229">
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-beige h-full flex flex-col relative" data-id="element-230">
              <div className="absolute top-5 right-5 bg-sage/15 text-sageDark text-xs font-medium uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-231">
                Рекомендуем
              </div>

              <div className="bg-navy p-8 md:p-10 text-center text-white" data-id="element-232">
                <div className="text-xs uppercase tracking-widest text-sage font-medium mb-3" data-id="element-233">
                  Наш сервис
                </div>
                <h3 className="font-serif text-2xl mb-6" data-id="element-234">
                  Независимая экспертная оценка
                </h3>
                <div className="flex items-end justify-center gap-2 mb-2" data-id="element-235">
                  <span className="text-5xl font-medium tracking-tight" data-id="element-236">
                    14 900
                  </span>
                  <span className="text-xl text-white/70 mb-1" data-id="element-237">₽</span>
                </div>
                <p className="text-white/70 text-sm" data-id="element-238">
                  Фиксированная цена. Без доплат.
                </p>
              </div>

              <div className="p-8 md:p-10 flex-1 flex flex-col" data-id="element-239">
                <ul className="space-y-3 mb-8 flex-1" data-id="element-240">
                  {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-241">
                      <div className="w-5 h-5 rounded-full bg-sageLight flex items-center justify-center shrink-0 mt-0.5" data-id="element-242">
                        <Check size={12} className="text-sageDark" data-id="element-243" />
                      </div>
                      <span className="text-navy text-sm" data-id="element-244">{feature}</span>
                    </li>)}
                </ul>

                <button onClick={() => openModal('report')} className="w-full bg-sage hover:bg-sageDark text-white py-4 rounded-xl font-medium text-lg transition-all duration-300 shadow-soft hover:shadow-md mb-3" data-id="element-245">
                  Получить заключение
                </button>

                <p className="text-center text-xs text-navyLight leading-relaxed" data-id="element-246">
                  Оплата после согласования с менеджером. Если случай не
                  подходит для дистанционного анализа — скажем сразу до оплаты.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-247">
          <p className="text-center text-sm text-navyLight max-w-2xl mx-auto mt-10 italic" data-id="element-248">
            Дешевле, быстрее и — главное — без риска получить «ещё одно мнение
            из той же системы».
          </p>
        </FadeIn>
      </div>
    </section>;
};